
import './App.css';
import React from "react";
import { ethers } from "ethers";
import { NoWalletInstalled } from './NoWalletInstalled';
import { ConnectWallet } from './ConnectWallet';
import contractAddress from "../contracts/contract-address.json";
import DonateBigBenArtifact from "../contracts/DonateBigBen.json";
import { Donate } from './Donate';
import { SuccessAlert } from './SuccessAlert';
import { Loading } from './Loading';


export class App extends React.Component {

  constructor(props) {

    super(props)

    this.initialStatesSetup = {
    
      connectedAddress: undefined,      
      successEventEmitted: false,
      isLoading: false
    }
    this.state = this.initialStatesSetup
  }

  async connectWallet() {
    // do stuff
    console.log('connect wallet');
    const [accountAddress] = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
    this.initialize(accountAddress);
   
  }

  async donate() {
    console.log('donate');
    console.log("User wallet:"+this.state.connectedAddress)
    console.log("contract address:"+contractAddress.Token)
    let amount = ethers.utils.parseEther("0.01");
   

    try { 
      this.setState ({
        isLoading: true,
      });

      let success = await this.contract.donateMe(amount,{
        value:amount,        
      })
  
      this.txHash = success.hash
      console.log(success.hash)
      console.log(success)
  
  
      this.contract.on("BigBenEvent", (userAddress,timeStamp) => {
        
        this.setState ({
          successEventEmitted: true,
        });
        console.log("event back:"+"userAddress:"+userAddress+ "time:"+timeStamp);
      });
    } catch {
      this.setState ({
         isLoading: false,
      });
    }
 

  }

  initialize(address) {

    console.log('initialize')
    console.log('address:'+address)
    this.setState ({
      connectedAddress: address,
    });
    
    this.initializeEthers()
  }

  async initializeEthers() {

    this.provider = new ethers.providers.Web3Provider(window.ethereum);

    this.contract = new ethers.Contract(
      contractAddress.Token,
      DonateBigBenArtifact.abi,
      this.provider.getSigner(0)
    );
  }

  render() {

    if (window.ethereum === undefined) {
      return <NoWalletInstalled/>
    }

    if (!this.state.connectedAddress) {
      return (
        <ConnectWallet connectWallet={() => this.connectWallet()}/>
      )  
    }

    if (this.state.isLoading) {
      return (
        <Loading/>
      )
    }

    if (this.state.successEventEmitted) {
      return (             
        <SuccessAlert txhash={this.txHash}/>
      )    
    } else {
      return (      
        <Donate donate={() => this.donate()}/>
      )  
    }
  }
}

export default App;
